/* tslint:disable:no-inferrable-types no-trailing-whitespace import-spacing typedef-whitespace align whitespace quotemark */

import {
  ComponentFactoryResolver,
  EmbeddedViewRef,
  ViewContainerRef
}                                 from '@angular/core';

import { DocumentWindow }         from './document.window';
import { DocumentWindowManager }  from './document.window.manager';
import { Logger }                 from '@/util/logger';

import { BlobService }            from '@/services/blob.service';
import { AuthenticationService}   from '@/services/authentication.service';
import { IdeService}              from '@/services/ide.service';
import { UserLogViewerMetadata }  from './user.log.viewer.metadata';

import { UserLogViewerComponent } from '@/components/user.log.viewer.component';

import * as $                     from 'jquery';

import {Subscription}             from 'rxjs';

import {ResizeObserver}           from 'resize-observer';

import {DocumentMetadata}         from '@/screens/ide/document.metadata';
import {Train}                    from '@/models/scenario/train';
import {DecisionPoint}            from '@/models/scenario/decision.point';

/**
 *
 * @class UserLogViewerWindow
 *
 * @brief window for working with 1 or more user logs (comparison mode)
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2021
 *
 */
export class UserLogViewerWindow extends DocumentWindow {

  /** access to the virtual file system */
  private blobber:           BlobService = null;

  /** access to user authentication */
  private auth:    AuthenticationService = null;

  /** access to user authentication */
  private ide:                IdeService = null;

  /** the document manager we are a tab  of */
  private manager: DocumentWindowManager = null;

  private dsn:         string            = '';
  private collection:  string            = '';
  private train:       Train             = null;
  private dp:          DecisionPoint     = null;

  /** the Angular component that is the actual user log panel component...which we are hosting */
  private viewer: UserLogViewerComponent = null;

  /** the resizer tracker */
  private resizeObserver: ResizeObserver = null;

  /** the observable we use to know when the component is ready */
  private readySub: Subscription;

  /** standard constructor */
  constructor(
    meta: UserLogViewerMetadata,
    manager: DocumentWindowManager
  ) {

    super(manager, meta, manager.layoutManager());

    Logger.debug('[UserLogViewerWindow] constructing...');

    this.manager     = manager;
    this.auth        = this.manager.authService();
    this.blobber     = this.manager.blobService();
    this.ide         = this.manager.ideService();

    this.dsn         = meta.dsn;
    this.collection  = meta.collection;
    this.train       = meta.train;
    this.dp          = meta.dp;

    this.initViewer();
  }

  /** restore the view (on current 'focus') */
  public initViewer() {

    Logger.debug(`[UserLogViewerWindow] => `, this.meta);

    const uvw: UserLogViewerWindow = this;

    const container: JQuery<HTMLElement> = $(`#${this.meta.id}`);

    if (!$(container) || !$(container).is('div')) {

      this.unReady();

      Logger.error(`[UserLogViewerWindow] missing hosting container (${uvw.meta.id})!`);

      return ;
    }

    $(container).html(`
<div id="user_log_${uvw.meta.id}" class="userlogpanelshell">
</div>
`);

    /*
     * wait for the HTML to actually update with the component selector above, this won't create the
     * component, its just HTML :)  But, we can use Angular's component factory etc. to create the
     * component and effective "host" an Angular component inside our DocumentWindow (which isn't
     * Angular based).
     *
     */

    const checkExist = setInterval(() => {

      const dom: HTMLElement = document.getElementById(`user_log_${uvw.meta.id}`) as HTMLElement;

      if (dom) {

        clearInterval(checkExist);

        Logger.debug(`[UserLogViewerWindow] inject user log viewer component ...`);

        const    view: ViewContainerRef         = uvw.ide.view;
        const factory: ComponentFactoryResolver = uvw.ide.componentResolver;


        const creator      = factory.resolveComponentFactory(UserLogViewerComponent);
        const componentRef = view.createComponent(creator);

        uvw.viewer        = componentRef.instance  as UserLogViewerComponent;

        const domElem      = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;

        /* ensure the new component is parented under our container */

        dom.appendChild(domElem);

        /*
         * add a self watch for changes in wrapper size...because sometime it will change because
         * the panels around it have changed in size...not because the browser has changed in size;
         * that is, its not a window resize event, so that kind of size change wouldn't normally
         * be caught.
         *
         */

        uvw.resizeObserver = new ResizeObserver(entries => {

          uvw.viewer.resize();

        });

        uvw.resizeObserver.observe( dom );

        /* load the user log tree when the user log component says its ready */

        uvw.readySub = uvw.viewer.ready.subscribe((status: boolean) => {

          if (status == false) {

            return ;
          }

          Logger.debug(`[UserLogViewerWindow] child component is ready!`);

          uvw.viewer.manager = uvw.manager;
          uvw.viewer.window  = uvw;

          /* do any init still remaining before we go live ... */

          uvw.viewer.finalize();

          /* go ahead and do the first time load */

          uvw.refocus(this.meta);

          /* register this window in its anchor group, first one is always the anchor. */

          if (uvw.manager.anchor(uvw.type) == null) {

            /*
             * there is no anchor yet, so use this one; we always default to the most
             * recently created window.
             *
             */

            uvw.manager.dropAnchor(uvw.type, uvw);
            uvw.viewer.dropAnchor();
          }

        });
      }

    }, 100);
  }

  /** after initialization, some windows may allow for resetting tot new content to view */
  public refocus(meta: DocumentMetadata, append: boolean=false) {

    if (this.viewer == null) {

      return ;
    }

    Logger.debug(`[UserLogViewerWindow] loading: `, meta);

    /* on demand loading of a tree */

    this.viewer.refocus(meta as UserLogViewerMetadata, append);

    /* update our title if needed */

    this.updateFocus(append);
  }

  public close(implied: boolean = false) {

    Logger.debug(`[UserLogViewerWindow] closing!`);

    if (this.viewer != null) {

      this.viewer.close();

      this.viewer = null;
    }

    if (this.resizeObserver != null) {

      this.resizeObserver.disconnect();

      this.resizeObserver = null;
    }

    this.readySub.unsubscribe();

    super.close(implied);
  }

  /** update the focus to current */
  private updateFocus(append: boolean = false) {

    Logger.debug(`[UserLogViewerWindow] focus updating...`);

    /*
     * either refocus the tree, or add a new one.  If the collection doesn't exist
     * yet in this panel, the mode is to append.
     *
     */











  }

}
